import { render } from "./FooterBar.vue?vue&type=template&id=7ac12d0c&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=7ac12d0c&scoped=true&lang=scss"

import exportComponent from "/Users/Sacha/PhpstormProjects/landgoedmorrenrun/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac12d0c"]])

export default __exports__